import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { createTextMaskInputElement } from 'text-mask-core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-coleta-pesquisador',
  templateUrl: './coleta-pesquisador.component.html',
  styleUrls: ['./coleta-pesquisador.component.scss']
})
export class ColetaPesquisadorComponent implements OnInit {
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;

  pesquisadorForm: FormGroup;
  outrasPesquisas: string = '';
  errorMessage: string ='';
  
  // Máscaras para os campos
  telefoneMask = ['+', '3', '9', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    public modalService: NgbModal,
    private router: Router,
    private util: UtilService
  ) {
    this.pesquisadorForm = this.fb.group({
      nomeCompleto: ['', Validators.required],
      cpf: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      endereco: ['', Validators.required],
      PESQUISADOR_BRASIL: [false],
      PESQUISADOR_ITALIA: [false],
      PESQUISADOR_OUTROS: [false]
    }, {
      validators: this.atLeastOneResearchAreaValidator()
    });
  }

  ngOnInit(): void {
  }

  // Validador personalizado para verificar se pelo menos uma área de pesquisa está selecionada
  private atLeastOneResearchAreaValidator() {
    return (formGroup: FormGroup) => {
      const brasil = formGroup.get('PESQUISADOR_BRASIL')?.value;
      const italia = formGroup.get('PESQUISADOR_ITALIA')?.value;
      const outros = formGroup.get('PESQUISADOR_OUTROS')?.value;

      if (!brasil && !italia && !outros) {
        return { atLeastOneResearchArea: true };
      }

      return null;
    };
  }

  // Getter para verificar se há erro de validação de área de pesquisa
  get hasResearchAreaError(): boolean {
    return this.pesquisadorForm.hasError('atLeastOneResearchArea') && 
           (this.pesquisadorForm.get('PESQUISADOR_BRASIL')?.touched || 
            this.pesquisadorForm.get('PESQUISADOR_ITALIA')?.touched || 
            this.pesquisadorForm.get('PESQUISADOR_OUTROS')?.touched);
  }

  navigateToSection(sectionId: string): void {
    this.router.navigate(['/site'], { fragment: sectionId });
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    if (this.pesquisadorForm.valid) {
      const formData = this.pesquisadorForm.value;

      let dados = {        
        "NOME": formData.nomeCompleto,
        "CPF": formData.cpf,
        "EMAIL": formData.email,
        "TELEFONE": formData.telefone,
        "ENDERECO": formData.endereco,
        "PESQUISADOR_BRASIL": formData.PESQUISADOR_BRASIL ? true : false,
        "PESQUISADOR_ITALIA": formData.PESQUISADOR_ITALIA ? true : false,
        "PESQUISADOR_OUTROS": formData.PESQUISADOR_OUTROS ? true : false,
        "OUTRAS_PESQUISAS": this.outrasPesquisas
      }

      let url = API + "Usuario/Cadastro/pesquisador";
      this.util.showLoading();
      // Criar novo pesquisador
      this.ajaxService.post(url, dados).subscribe({
        next: (response) => {
          this.util.closeLoading();
          // Limpar o formulário
          this.pesquisadorForm.reset();
          this.outrasPesquisas = '';
          
          // Mostrar mensagem de sucesso
          this.modalService.open(this.successModal, { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        },
        error: (error) => {
          this.util.closeLoading();
          this.errorMessage = error.message;
          //console.error('Erro ao criar pesquisador:', error.message);
          // Mostrar mensagem de erro
          this.modalService.open(this.errorModal , { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        }
      });
    }
  }

  // Getters para validação dos campos
  get nomeCompleto() { return this.pesquisadorForm.get('nomeCompleto'); }
  get cpf() { return this.pesquisadorForm.get('cpf'); }
  get email() { return this.pesquisadorForm.get('email'); }
  get telefone() { return this.pesquisadorForm.get('telefone'); }
  get endereco() { return this.pesquisadorForm.get('endereco'); }
} 